import React from 'react';
import styled from 'styled-components';
import { Skeleton, Box } from '@landr/maestro';

const LabelCardArtworkSkeleton = styled(Skeleton)`
    &::before {
        content: ' ';
        position: relative;
        display: block;
        padding-bottom: 100%;
    }
`;

export const LabelCardSkeleton = (): JSX.Element => (
    <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        data-testid="artist-card-skeleton-wrapper"
    >
        <LabelCardArtworkSkeleton variant="round" />
        <Skeleton height="16px" mt="12px" width="70%" />
    </Box>
);
